export const FEATURE_IGNORE_KEY = '--IGNORE--' as const;

// used in all viewer keys associated with material stock visualizations
export const MATERIAL_INDICATOR = '-_MAT_IND_-' as const;

export const FEATURE_LOADING_TYPES = {
  FEATURE: 'FEATURE',
  FEEDBACK: 'FEEDBACK',
} as const;
